import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-around h-full mt-[4.5rem] px-3" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center" }

import DefaultLayout from "../layouts/DefaultLayout.vue";
import AgeSelector from "@/components/AgeSelector.vue";
import { useGlobalStore } from "../stores/global";


export default /*@__PURE__*/_defineComponent({
  __name: 'ageCheck',
  setup(__props) {

const globalStore = useGlobalStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(AgeSelector),
          _createElementVNode("button", {
            type: "button",
            class: "mt-5 mb-4 max-w-[92%] rounded-xl border-2 border-jm_orange bg-jm_dark_green/90 px-5 py-3 text-center text-[13px] font-bold uppercase leading-tight text-jm_white shadow-lg shadow-black/20 underline decoration-jm_orange decoration-2 underline-offset-4",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(globalStore).openTermsAndConditions('ageCheck')))
          }, _toDisplayString(_ctx.$t("age_check.legal_conditions")), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "relative flex flex-col justify-center items-center" }, null, -1))
      ])
    ]),
    _: 1
  }))
}
}

})